<div class="form searchbox" [ngClass]="{'top-element': searchResultsVisible || searchInputMobileVisible, 'is-open': searchInputMobileVisible}" #dropdown>
    <input type="text" [placeholder]="placeholder" [formControl]="query" (focus)="focusInput()" autocomplete="off" />

    <div id="coho__search--results" [class.visible]="searchResultsVisible">
        <div class="results__container">
            <div class="searching" *ngIf="searchingResults && !finishedResults">
                <loading-indicator></loading-indicator>
            </div>
            <div class="zero-state" *ngIf="noResults">
                <p><strong>Sorry.</strong> We couldn't find anything.</p>
                <p>Please try again</p>

            </div>
            <div class="results__container-inner" *ngIf="finishedResults && !searchingResults && !noResults">
                <a *ngFor="let result of searchResults.majorAddresses" (click)="clickLink()" [routerLink]="['/find-a-home', result.reference]">
                    <div class="area">
                        <div class="area__icon">
                            <svg-icon class="icon icon-find icon--white" name="icon-find" role="img"></svg-icon>
                        </div>
                        <div class="area__description">
                            <p class="">
                                <strong>{{result.label}},</strong>
                                {{result.parentAddress.label}}
                            </p>
                        </div>
                    </div>
                </a>
                <a *ngFor="let result of searchResults.minorAddresses" (click)="clickLink()" [routerLink]="['/find-a-home', result.parentAddress.reference, result.reference]">
                    <div class="area">
                        <div class="area__icon">
                            <svg-icon class="icon icon-area icon--white" name="icon-area" role="img"></svg-icon>
                        </div>
                        <div class="area__description">
                            <p class="">
                                <strong>{{result.label}}, </strong>
                                {{result.parentAddress.label}}
                            </p>
                        </div>
                    </div>
                </a>
                <a *ngFor="let result of searchResults.roomPreviews" (click)="clickLink()" [routerLink]="['/find-a-home', result.majorArea.reference, 'home', result.propertyPublicReference, result.reference]">
                    <div class="area">
                        <div class="area__icon">
                            <svg-icon class="icon icon-house icon--white" name="icon-house" role="img"></svg-icon>
                        </div>
                        <div class="area__description">
                            <p class="">
                                <strong>{{result.headlineDescription}}, </strong>
                                <ng-container *ngIf="result.minorArea != null">{{result.minorArea.label}},</ng-container> {{result.majorArea.label}}
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
